import React from "react";
import {Radio} from "antd";
import {
    defaultOptionKeys,
    defaultSeparator,
    InputWrapper,
    SplitInputWrapperProps,
} from "../../functions";
import {RadioInputBoxProps} from "./interface";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";

const RadioInputBox: React.FC<RadioInputBoxProps> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps,
    } = SplitInputWrapperProps(props);
    const {options, type, buttonStyle = "solid", ...rest} = inputProps;

    const valueKey = options?.valueKey || defaultOptionKeys.value;
    const textKey = options?.textKey || defaultOptionKeys.text;
    const separator = options?.separator || defaultSeparator;
    let textKeys: any[] = [];
    if (Array.isArray(options?.textKey)) {
        textKeys = options?.textKey;
    }

    const renderOptions = options?.list?.map((option: any) => {
        if (
            options?.rejectedValues &&
            options?.rejectedValues.includes(option[valueKey]) &&
            !options?.requiredValues.includes(option[valueKey])
        ) {
            return null;
        }
        const renderOptionText =
            textKeys.length <= 0
                ? option[textKey]
                : textKeys.map((text_key) => option[text_key] || text_key).join(separator);

        if (type === "button") {
            return (
                <Radio.Button key={option[valueKey]} value={option[valueKey]}>
                    {renderOptionText}
                </Radio.Button>
            );
        } else {
            return (
                <Radio key={option[valueKey]} value={option[valueKey]}>
                    {renderOptionText}
                </Radio>
            );
        }
    });

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.other());
    }

    const newFormProps = Object.assign({}, formProps);
    !options?.list && newFormProps.label && delete newFormProps.label;
    !options?.list && (newFormProps.valuePropName = "checked");

    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...newFormProps}
        >
            {renderOptions ? (
                <Radio.Group {...rest} buttonStyle={buttonStyle}>
                    {renderOptions}
                </Radio.Group>
            ) : (
                <Radio {...rest}>{formProps.label}</Radio>
            )}
        </InputWrapper>
    );
};

export default RadioInputBox;
